export class Vorschaden {
  schadenjahr: number | null;
  schadenhoehe: number | null;
  schadenart = "";

  constructor() {
    this.schadenjahr = null;
    this.schadenhoehe = null;
  }
}
